export enum EmailStatus {
  UNKNOWN,
  VALID,
  INVALID,
}
